import React from 'react'

import { GoogleTagManager, GoogleAnalytics } from '@next/third-parties/google'
import { useAnalytics } from '@/src/hooks/useAnalytics'

const Analytics = () => {
  const { config } = useAnalytics()

  if (!config.isEnabled) {
    // Development warning
    if (config.isProduction) {
      return (
        <script
          dangerouslySetInnerHTML={{
            __html: `
              console.warn('Analytics not loaded: Missing environment variables NEXT_PUBLIC_GTM_ID or NEXT_PUBLIC_GOOGLE_ANALYTICS_ID');
            `
          }}
        />
      )
    }
    return null
  }

  return (
    <>
      <GoogleTagManager gtmId={config.gtmId} />
      <GoogleAnalytics gaId={config.gaId} />
    </>
  )
}

export default Analytics
